import { useApi } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";

export function useDeleteLead() {
  const api = useApi();
  const queryClient = useQueryClient();

  const { mutateAsync, isPending, error, isSuccess } = useMutation({
    mutationFn: async (leadId: number) => {
      return api.admin.leadsV2.deleteLead({
        params: { id: leadId },
      });
    },
    onSuccess: () => {
      // Invalidate all leads queries to refetch the data
      queryClient.invalidateQueries({ queryKey: ['admin', 'leads-v2'] });
    },
  });

  return {
    mutateAsync,
    isPending,
    error,
    isSuccess,
  };
}

